<template>
    <v-container grid-list-md fluid class="pt-0">
        <v-timeline align-top dense>
            <v-timeline-item
                v-for="(item, i) in items"
                :color="checkColor(item)"
                :icon="checkIcon(item)"
                :key="i"
            >
                <v-row
                    justify="space-between"
                    class="elevation-2 mr-2 pa-2"
                    style="background-color: #fafafa"
                >
                    <v-col class="pr-0 text-left py-0">
                        <div class="title">{{ getTitle(item) }}</div>
                        <div class="overline mt-2">{{ getDescription(item) }}</div>
                    </v-col>
                    <v-col cols="2" class="pl-2 pr-0 py-0">
                        <div>{{ getRecurrence(item) }}</div>
                    </v-col>
                    <v-col cols="4" class="pl-2 pr-0 py-0">
                        <v-progress-linear
                            rounded
                            :height="25"
                            color="primary"
                            :model-value="item.percentage"
                        >
                            <strong class="white--text">{{
                                item.missingCount + " / " + item.neededCount
                            }}</strong>
                        </v-progress-linear>
                    </v-col>
                    <v-col cols="1" class="text-center pl-2 py-0">
                        <v-btn-icon
                            icon="$remove_red_eye"
                            color="secondary"
                            @click.stop="showDetails(item)"
                        />
                        <!-- <v-btn icon color="secondary" v-if="item.action" @click.stop="openAction(item)">
                        <v-icon>$spellcheck</v-icon>
                    </v-btn> -->
                    </v-col>
                </v-row>
            </v-timeline-item>
        </v-timeline>
    </v-container>
</template>

<script lang="ts">
import colors from "vuetify/lib/util/colors";
import moment from "moment-timezone";
import { Apollo } from "@/decorators";

import AUDIT_ITEMS_QUERY from "../../graphql/audit/AuditItems.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component
export class CheckRecurentPurchaseInvoice extends Vue {
    @Prop({ default: "" }) companyId: string;

    get loading() {
        if (this.$apollo.queries.items) {
            return this.$apollo.queries.items.loading;
        }
        return false;
    }

    @Apollo({
        query: AUDIT_ITEMS_QUERY,
        variables() {
            return {
                companyId: this.companyId,
                auditCheck: "CheckRecurrentPurchaseInvoice",
                accountingPeriodId: this.$route.params.accountingPeriodId,
            };
        },
        skip() {
            return this.companyId === null;
        },
        async specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.auditItems && data.auditItems.items) {
                    this.items = data.auditItems.items;
                } else {
                    this.items.splice(0, this.items.length);
                }
            }
        },
    })
    items: [] = [];

    checkColor(item) {
        if (item.missingCount) {
            return colors.red.accent1;
        }
        return colors.green.accent1;
    }

    firstColStyle(check) {
        return `background-color: ${this.checkColor(check)};`;
    }

    checkIcon(item) {
        if (item.missingCount) {
            return "report_problem";
        }
        return "check";
    }

    showDetails(item) {}

    getTitle(item) {
        if (item.company) {
            return item.company.shortName || item.company.name;
        }
        return "";
    }

    getDescription(item) {
        let description = this.$t(
            "audit.CheckRecurrentPurchaseInvoice.missingCount",
            [item.missingCount],
            item.missingCount,
        );
        if (item.dateDocs && item.dateDocs.length && item.missingCount) {
            let separator = " : ";
            for (const dateDoc of item.dateDocs) {
                if (!dateDoc.documents.length) {
                    description += separator + moment(dateDoc.date).format("MMMM YYYY");
                    separator = ", ";
                }
            }
        }
        return description;
    }

    getRecurrence(item) {
        let description = "";
        if (item.recurrence) {
            description += "Tous les " + (item.recurrence === 1 ? "" : item.recurrence) + " mois";
        }
        return description;
    }
}

export default toNative(CheckRecurentPurchaseInvoice);
</script>
